(function () {
  function setCenterClass(swiperEl) {
    var slides = swiperEl.querySelectorAll('.swiper-slide');
    slides.forEach(function (s) { s.classList.remove('is-center'); });
    var active = swiperEl.querySelector('.swiper-slide-active');
    if (active) active.classList.add('is-center');
  }

  // Handle Dragging Logic
  function initComparison(root) {
    const comparisons = root.querySelectorAll('.ba-comparison');
    comparisons.forEach(comp => {
      const handle = comp.querySelector('.ba-handle');
      if (!handle || comp.dataset.baBound === 'true') return; // filler clones are bound once, on their first pass
      comp.dataset.baBound = 'true';

      let isDragging = false;

      const move = (clientX) => {
        const rect = comp.getBoundingClientRect();
        let x = clientX - rect.left;
        let percent = (x / rect.width) * 100;
        percent = Math.min(100, Math.max(0, percent));
        comp.style.setProperty('--ba-pos', percent + '%');
      };

      handle.addEventListener('pointerdown', (e) => {
        isDragging = true;
        e.stopPropagation(); // Stops Swiper from sliding when moving the handle
        handle.setPointerCapture(e.pointerId);
      });

      window.addEventListener('pointermove', (e) => {
        if (!isDragging) return;
        move(e.clientX);
      });

      window.addEventListener('pointerup', (e) => {
        isDragging = false;
        handle.releasePointerCapture(e.pointerId);
      });
    });
  }

  window.initBeforeAfterSwiper = function (selector) {
    var root = document.querySelector(selector);
    if (!root) return;

    var sectionId = root.dataset.sectionId;
    var loopAttr = root.dataset.loop === 'true' || root.dataset.loop === 'True' || root.dataset.loop === '1';
    var arrowsAttr = root.dataset.arrows === 'true' || root.dataset.arrows === 'True' || root.dataset.arrows === '1';
    var swiperEl = root.querySelector('.swiper');

    // Slides added to satisfy Swiper 11's loop minimum need their handles wired up too
    swiperEl.addEventListener('swiper-loop-fix:slides-cloned', function () {
      initComparison(root);
    });

    var swiper = new Swiper(swiperEl, {
      centeredSlides: true,
      grabCursor: false, // Turned off so it doesn't conflict with your handle cursor
      loop: !!loopAttr,
      loopPreventsSliding: false,
      // Arrows are opt-in per section and hidden below the desktop breakpoint by CSS
      navigation: arrowsAttr
        ? { prevEl: '#ba-prev-' + sectionId, nextEl: '#ba-next-' + sectionId }
        : false,
      pagination: {
        el: '.swiper-pagination-' + sectionId,
        clickable: true
      },
      breakpoints: {
        0: { slidesPerView: 1.2, spaceBetween: 0 },
        480: { slidesPerView: 1.2, spaceBetween: 0 },
        768: { slidesPerView: 3, spaceBetween: 16 }
      },
      on: {
        init: function () {
          setCenterClass(swiperEl);

          var instance = this;
          setTimeout(function () {
            if (!instance.destroyed) instance.update();
          }, 100);
        },
        slideChange: function () { setCenterClass(swiperEl); },
        slideChangeTransitionEnd: function () { setCenterClass(swiperEl); },
        resize: function () { setCenterClass(swiperEl); }
      }
    });

    // Runs after init so any filler clone created during construction is included
    initComparison(root);

    return swiper;
  };
})();